<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="3" class="print_col">
              <v-select
                density="compact"
                variant="outlined"
                hide-details="auto"
                :items="zoneList"
                :label="$t('tanaoroshiSai.label.targetZoneCode')"
                item-title="zoneName"
                item-value="zoneCode"
                v-model="searchCondition.targetZoneCode"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="3" class="print_col">
              <v-select
                  density="compact"
                  variant="outlined"
                  hide-details="auto"
                  :items="[
                      {'key':1, 'label': $t('tanaoroshiSai.label.little')},
                      {'key':2, 'label': $t('tanaoroshiSai.label.excess')},
                      {'key':3, 'label': $t('tanaoroshiSai.label.matched')},
                      {'key':4, 'label': $t('tanaoroshiSai.label.hasDifference')},
                      ]"
                  :label="$t('tanaoroshiSai.label.difference')"
                  item-title="label"
                  item-value="key"
                  v-model="searchCondition.filterLoss"
                  clearable
              ></v-select>
            </v-col>
            <v-col cols="3" class="print_col">
              <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.janCode"
                :label="$t('tanaoroshiSai.label.janCode')" />
            </v-col>
            <v-col cols="3" class="print_col">
              <v-text-field density="compact" variant="outlined" hide-details="auto"
                v-model="searchCondition.productNumber"
                :label="$t('tanaoroshiSai.label.productNumber')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="print_col">
              <v-switch class="no_print" v-model="showZeroInventory" color="blue" inset :label="$t('tanaoroshiSai.label.showZeroInventory')"></v-switch>
              <div class="print_only">{{ this.showZeroInventory ? $t('tanaoroshiSai.label.printShowZeroInventoryOn') : $t('tanaoroshiSai.label.printShowZeroInventoryOff') }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <template v-for="header in headers" :key="header">
                      <template v-if="header == 'adjustementSuuryo'">
                        <th class="no_print"  @click.stop="tableSort(header)" :style="cursorCheck(header)">{{ $t("tanaoroshiSai.label.table." + header) }}</th>
                      </template>
                      <template v-else>
                        <th @click.stop="tableSort(header)" :style="cursorCheck(header)">{{ $t("tanaoroshiSai.label.table." + header) }}</th>
                      </template>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in filteredDataList" :key="data.no"
                    @click="useDiffLocation && openLocationDialog(data)" :style="useDiffLocation ? cursorCheck(null) : null">
                    <template v-for="header in headers" :key="header">
                      <template v-if="header == 'adjustementSuuryo'">
                        <td class="no_print">
                          <v-text-field density="compact" variant="outlined" hide-details="auto"
                            v-model="data.adjustmentQuantity"
                            @input="fixAdjustmentQuantity(data, $event)"
                            @click.stop
                             />
                        </td>
                      </template>
                      <template v-else>
                        <td :class="{'list__row--has-adjustment-for-apv': hasAdjustmentInfoForApv(data)}">{{ data[header] }}</td>
                      </template>
                    </template>
                  </tr>
                  <tr>
                    <td :colspan="headers.length">
                      
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3">
              <span class="no_print" v-if="canAdjustment && useLocationAdjustment">
                {{ $t('tanaoroshiSai.label.noticeForApvAdjustment') }}
              </span>
            </v-col>
            <v-col cols="6">
              <v-pagination
                v-model="currentPageNo"
                :length="maxPageNo"/>
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select
                    density="compact"
                    variant="outlined"
                    hide-details="auto"
                    v-model="displayPerPage"
                    :items="displayPerPageItem"
                    item-title="name"
                    item-value="value"
                    :label="$t('common.label.displayCountPerPage')"
                    @update:modelValue = "resetCondition()"
                    return-object/>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  {{displayContentNo.minNo}} - {{displayContentNo.maxNo}}{{ $t('common.label.displayedDataRange') }} / {{ sortedTable.length }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>

            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn
                v-if="canAdjustment"
                dark
                class="px-8 bg-indigo-darken-1 mr-5"
                elevation="2"
                @click="openAdjustmentDialog"
                :disabled="!hasAdjustment">{{ $t('tanaoroshiSai.action.save') }}
              </v-btn>
              <v-btn
                v-if="canAdjustment"
                dark
                class="px-8 bg-indigo-darken-1 mr-5"
                elevation="2"
                @click="openAddJanDialog">{{ $t('tanaoroshiSai.action.addJan') }}
              </v-btn>
              <v-btn
                v-if="useHtImport"
                dark
                class="px-8 bg-indigo-darken-1 mr-5"
                elevation="2"
                :loading="isHtUploadLoading"
                :disabled="isHtUploadLoading || !canImportHtResult"
                @click="onImportHtResultClick"
                >{{ $t('tanaoroshiSai.action.importHtResult') }}
              </v-btn>
              <v-btn
                dark
                class="px-8 bg-indigo-darken-1 mr-5"
                elevation="2"
                @click="downloadCsv"
                :disabled="dataList.length == 0">{{ $t('tanaoroshiSai.action.outputCsv') }}
              </v-btn>

              <v-btn
                dark
                class="px-8 bg-indigo-darken-1"
                elevation="2"
                @click="print"
                :disabled="dataList.length == 0">{{ $t('tanaoroshiSai.action.print') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <ErrorDialog v-if="dataError" :URL="previousURL"/>
        <TanaoroshiSaiLocationDialog
          v-if="locationDialogVisible"
          :dialog-data="locationDialog"
          :handle-close="closeLocationDialog"
          :handle-save="saveLocationDialog"
        />
        <TanaoroshiAdjustmentDialog v-if="adjustmentDialogVisible" :dialog-data="adjustmentDialog" :handle-ok="confirmAdjustmentOk"
        :handle-cancel="confirmAdjustmentCancel" />
        <TanaoroshiAddJanDialog v-if="addJanDialogVisible" :dialog-data="addJanDialog" :handle-ok="confirmAddJanOk"
        :handle-cancel="confirmAddJanCancel" />
        <!-- HT棚卸実績取込: 確認ダイアログ/ファイル選択/通知 -->
        <ConfirmDialog v-if="confirmDialogVisible" :dialog-data="confirmDialog" :handle-ok="uploadHtResult"
          :handle-cancel="cancelHtConfirmDialog" />
        <input v-if="useHtImport" ref="htUploadInput" type="file" accept=".dat" style="display: none" @change="selectedHtFile" />
        <v-snackbar v-model="toast.visible" :color="toast.color" location="top" timeout="4000">
          {{ toast.message }}
        </v-snackbar>
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import Vue from "vue";
import AppWrapperView from "@/components/views/AppWrapperView";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import api from "@/apis/staff";
import store from "@/store";
import utils from "@/utils";
import ErrorDialog from "@/components/dialog/ErrorDialog";
import TanaoroshiSaiLocationDialog from "@/components/dialog/TanaoroshiSaiLocationDialog";
import TanaoroshiAdjustmentDialog from "@/components/dialog/TanaoroshiAdjustmentDialog";
import TanaoroshiAddJanDialog from "@/components/dialog/TanaoroshiAddJanDialog";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import constant from "@/utils/constant"
import TableSorter from "@/components/TableSorter";

/** HT棚卸実績取込で許可されているファイル名 */
const HT_TANA_FILE_NAME = "ht_tana.dat";

export default {
  components: {AppWrapperView, ErrorDialog, TanaoroshiSaiLocationDialog, TanaoroshiAdjustmentDialog, TanaoroshiAddJanDialog, ConfirmDialog},
  computed: {
    // １つ目は必ず不必要なゾーンなので、除外する
    zoneList() {
      const clonedZoneList = this.tanaoroshi?.zoneList.map(x => x) ?? [];
      clonedZoneList.shift();
      // APV在庫の場合はゾーンコードリストを表示しない
      const	nameerp = this.$t('tanaoroshiSai.label.nameerp');
      if(this.tanaoroshi?.inventoryMode == 2){
        return [];
      }
      return clonedZoneList;
    },
    
    //どの部分を表示しているのか
    displayContentNo(){
      const minNo = this.dataList.length != 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
      const maxNo = this.displayPerPage.value * (this.currentPageNo);
      if(maxNo > this.sortedTable.length || this.displayPerPage.value == 0){
        return {minNo: minNo, maxNo: this.sortedTable.length};
      }
      return {minNo: minNo, maxNo: maxNo};
    },

    //最大ページ
    maxPageNo() {
      if(this.displayPerPage.value == 0) return 0;
      return Math.ceil(this.sortedTable.length/this.displayPerPage.value);
    },

    //ソート&日付変換後のデータ
    sortedTable() {
      let tempArray = this.dataList.map(x => x);
      if(this.sortState.target != ""){
        tempArray = tempArray.sort(TableSorter.getSorter(this.sortState.target, this.sortState.ascent));
      }

      // フィルター
      // ロケ
      if(this.searchCondition.targetZoneCode != null) {
        tempArray = tempArray.filter(x => x.zoneCode == this.searchCondition.targetZoneCode)
      }
      
      // 差異
      if(this.searchCondition.filterLoss != null) {
        // 過少 予定数 > 読み取り数
        if(this.searchCondition.filterLoss == 1) tempArray = tempArray.filter(x => x.planSuuryo > x.resultSuuryo)
        // 過剰 予定数 < 読み取り数
        if(this.searchCondition.filterLoss == 2) tempArray = tempArray.filter(x => x.planSuuryo < x.resultSuuryo)
        // 一致 予定数 = 読み取り数
        if(this.searchCondition.filterLoss == 3) tempArray = tempArray.filter(x => x.planSuuryo == x.resultSuuryo)
        // 誤差 予定数 != 読み取り数
        if(this.searchCondition.filterLoss == 4) tempArray = tempArray.filter(x => x.planSuuryo != x.resultSuuryo)
      }

      // JANコード
      if(this.searchCondition.janCode != "") {
        tempArray = tempArray.filter(x => x.janCode == this.searchCondition.janCode);
      }
      // 品番
      if(this.searchCondition.productNumber != "") {
        tempArray = tempArray.filter(x => x.productCode == this.searchCondition.productNumber);
      }
      // 0件データ非表示
      if (!this.showZeroInventory) {
        tempArray = tempArray.filter(x => x.planSuuryo != 0 || x.resultSuuryo != 0);
      }
      // 変換
      tempArray = tempArray.map((x, index) => {
        // noはなし
        x.no = index + 1;
        return x;
      })
      
      return tempArray;
    },
    canAdjustment() {
      return this.inventoryStatus == constant.INVENTORY_STATUS.SAVED;
    },
    canImportHtResult() {
      // HT取込は「実施中」または「保存済み」のみ許可
      return this.inventoryStatus == constant.INVENTORY_STATUS.STARTED
        || this.inventoryStatus == constant.INVENTORY_STATUS.SAVED;
    },
    hasAdjustment() {
      // ロケ別調整の場合、行に更新情報(ロケごとの調整数)が保持されている
      if (this.useLocationAdjustment) {
        return this.dataList.some(e => this.hasAdjustmentInfoForApv(e));
      }
      // それ以外の場合、行に更新数量が保持されている
      return this.dataList.some(e => e.adjustmentQuantity);
    },
    // ページ区切り後のデータ
    filteredDataList() {
      const tempArray = this.sortedTable;
      return tempArray.slice(this.displayContentNo.minNo-1, this.displayContentNo.maxNo);
    },
    // ヘッダー
    headers() {
      let def = this.$getTableDef("TanaoroshiSaiPage");
      // ロケ別調整の場合、数量調整はロケ別実績ポップアップで入力する
      if (!this.canAdjustment || this.useLocationAdjustment) {
        def = def.filter(e => e != "adjustementSuuryo");
      }
      return def;
    },
    // 上位棚卸判定
    isApvInventory() {
      return this.tanaoroshi?.inventoryMode == constant.INVENTORY_MODE.ERP;
    },
    // 上位棚卸をロケ別に数量調整するか(ロケ別実績表示が有効な場合のみ)
    useLocationAdjustment() {
      return this.useDiffLocation && this.isApvInventory;
    },

  },
  data: () => ({
    // paramより
    tanaoroshi: null,
    shopCode: null,
    dataError: false,
    searchDatetime: null,
    dataList: [],

    searchCondition: {
      targetZoneCode: null, // ロケーション
      filterLoss : null, // 差異
      janCode: "",
      productNumber: ""
    },
    inventoryStatus: null,

    currentPageNo: 1,
    //１ページ表示数
    displayPerPage: {},
    displayPerPageItem: [],
    //ソートの状態
    sortState: {target: "", ascent: true},

    // エラー時の遷移先
    previousURL: Paths.TANAOROSHI,
    htSerialZoneMap: null,
    // 調整ダイアログ表示フラグ
    adjustmentDialogVisible: false,
    // 調整ダイアログに渡すデータ
    adjustmentDialog: {
    },
    // 棚卸追加フラグ
    addJanDialogVisible: false,
    // 棚卸追加ダイアログに渡すデータ
    addJanDialog: {
    },
    showZeroInventory: false,
    // HT棚卸実績取込の使用有無(FO向け。設定マスタ USE_HT_TANAOROSHI_IMPORT)
    useHtImport: !!store.getFeatureFlags().useHtTanaoroshiImport,
    // ロケ別実績表示の使用有無(FO向け。設定マスタ USE_TANAOROSHI_DIFF_LOCATION)
    useDiffLocation: !!store.getFeatureFlags().useTanaoroshiDiffLocation,
    // ロケ別実績ダイアログ表示フラグ
    locationDialogVisible: false,
    // ロケ別実績ダイアログに渡すデータ
    locationDialog: {
      locationList: [],
      loading: false,
    },
    // ポップアップに表示している行
    selectedLocation: null,
    // HT棚卸実績取込の確認ダイアログ
    confirmDialogVisible: false,
    confirmDialog: {
      message: null,
    },
    // アップロード対象のHTファイル
    htUploadFile: null,
    // 取込中のローディング制御
    isHtUploadLoading: false,
    // 取込結果・ロケ別実績取得エラーの通知
    toast: {
      visible: false,
      message: "",
      color: "success",
    },
  }),

  methods: {

    fixAdjustmentQuantity(data, event) {
      const val = event.target.value;
      data.adjustmentQuantity = val.replace(/[^0-9]/g, '');
    },
    cursorCheck(value){
      return "cursor: pointer;"
    },

    //テーブルの条件リセット
    resetCondition(){
      //１ページ目
      this.currentPageNo = 1;
      //ソートなし
      this.sortState.target = "";
      this.sortState.ascent = true;
    },
    tableSort(headValue) {
      if(headValue == "no") return;
      if(headValue == "adjustementSuuryo") return;
      this.currentPageNo = 1;
      if(this.sortState.target == headValue){
        this.sortState.ascent = !this.sortState.ascent;
      }
      else{
        this.sortState.target = headValue;
        this.sortState.ascent = true;
      }
    },

    reload() {
      api.post("/tanaoroshi/diff/list/search", {
          tanaoroshiId: this.tanaoroshi.tanaoroshiId ?? "",
          shopCode: this.shopCode ?? "",
        }
      )
      .then((response)=>{

        const hasErr = response.data.status == '1';
        const hasData = response.data.results?.diffList?.length ?? 0 != 0;
        const inventoryStatus = response.data.results?.inventoryStatus;
        this.inventoryStatus = inventoryStatus;
        // エラーあり、またはデータが無く保存も不可の場合は、エラーとし、再検索させる
        if(hasErr || (!hasData && !this.canAdjustment)){
          this.dataError = true;
        }
        this.dataList = response.data.results?.diffList ?? [];
        this.htSerialZoneMap = response.data.results?.htSerialZoneMap;
        this.searchDatetime = this.getTimestamp();
        this.inventoryStatus = inventoryStatus;
      })
      .catch((error) => {
        // back previous page
        this.dataError = true;
      })
      this.resetCondition();
    },
    downloadCsv() {
      utils.simpleDownloadCsv(this.headers.filter(e => e != "adjustementSuuryo"),
        this.sortedTable, "tanaoroshiSai.label.table.", 'tanaoroshiSai.fileNamePrefix.csv', this.$t);
    },
    print() {
      window.print();
    },
    // 保存ダイアログ表示
    openAdjustmentDialog() {
      let updateList = [];
      if (this.useLocationAdjustment) {
        // 上位棚卸はJANごとに集約されている。ロケごとの調整数はポップアップで入力した内容を使う。
        for (const target of this.dataList.filter(e => this.hasAdjustmentInfoForApv(e))) {
          for (const e of target.adjustmentInfo) {
            // JAN単位の行にポップアップの調整情報(ゾーンコード・調整数)を上書きして更新情報を作る
            updateList.push({...target, ...e});
          }
        }
      } else {
        updateList = this.dataList.filter(e => 'adjustmentQuantity' in e && e['adjustmentQuantity'] != "");
      }
      this.adjustmentDialog = {
        tanaoroshiId: this.tanaoroshi.tanaoroshiId,
        siteCode: this.shopCode,
        updateList: updateList,
        searchDatetime: this.searchDatetime
      }
      this.adjustmentDialogVisible = true;
    },
    // 保存ダイアログキャンセル
    confirmAdjustmentCancel() {
      this.adjustmentDialogVisible = false;
    },
    // 保存ダイアログOK押下
    confirmAdjustmentOk() {
      this.reload();
      this.adjustmentDialogVisible = false;
    },
    // 棚卸情報追加ダイアログ表示
    openAddJanDialog() {
      this.addJanDialog = {
        tanaoroshiId: this.tanaoroshi.tanaoroshiId,
        siteCode: this.shopCode,
        searchDatetime: this.searchDatetime,
        htSerialZoneMap: this.htSerialZoneMap,
      }
      this.addJanDialogVisible = true;
    },
    // 棚卸情報追加ダイアログキャンセル
    confirmAddJanCancel() {
      this.addJanDialogVisible = false;
    },
    // 棚卸情報追加ダイアログOK押下
    confirmAddJanOk() {
      this.reload();
      this.addJanDialogVisible = false;
    },
    /**
     * HT棚卸実績取込のファイル選択ダイアログ表示
     */
    onImportHtResultClick() {
      this.htUploadFile = null;
      this.$refs.htUploadInput.value = null;
      this.$refs.htUploadInput.click();
    },
    /**
     * 選択したファイルを受け取り、確認ダイアログを表示
     */
    selectedHtFile() {
      const fileInput = this.$refs.htUploadInput;
      const selectedFile = fileInput && fileInput.files && fileInput.files[0];
      if (!selectedFile) {
        this.htUploadFile = null;
        return;
      }

      const fileName = selectedFile.name ?? "";
      // 違うファイル名ならエラー表示
      if (fileName !== HT_TANA_FILE_NAME) {
        this.showToast(this.$t("tanaoroshiSai.message.invalidFileName", [HT_TANA_FILE_NAME]), "error");
        this.htUploadFile = null;
        fileInput.value = null;
        return;
      }

      this.htUploadFile = selectedFile;
      this.confirmDialog.message = this.$t("tanaoroshiSai.message.importHtConfirm", [this.htUploadFile.name]);
      this.confirmDialogVisible = true;
    },
    /**
     * 確認ダイアログを閉じ、メッセージを初期化
     */
    closeConfirmDialog() {
      this.confirmDialogVisible = false;
      this.confirmDialog.message = null;
    },
    /**
     * 取込キャンセル時にダイアログと選択ファイルをクリア
     */
    cancelHtConfirmDialog() {
      this.closeConfirmDialog();
      this.htUploadFile = null;
    },
    /**
     * 通知を表示
     * @param {string} message 表示メッセージ
     * @param {string} color 色
     */
    showToast(message, color) {
      this.toast.message = message;
      this.toast.color = color;
      this.toast.visible = true;
    },
    /**
     * HT棚卸実績ファイルをアップロードし、結果を通知
     */
    uploadHtResult() {
      if (!this.htUploadFile) {
        this.closeConfirmDialog();
        return;
      }
      this.isHtUploadLoading = true;
      this.closeConfirmDialog();
      const formData = new FormData();
      formData.append("file", this.htUploadFile);
      formData.append("tanaoroshiId", this.tanaoroshi?.tanaoroshiId ?? "");
      api.postFile("/ht_tanaoroshi_jisseki/upload", formData)
        .then((response) => {
          if (response.data?.status == 0) {
            this.showToast(this.$t("tanaoroshiSai.message.importHtSuccess"), "success");
            this.reload();
          } else {
            const errorMessage = response.data?.errorMessage
              ?? this.$t("tanaoroshiSai.message.importHtError");
            this.showToast(errorMessage, "error");
          }
        })
        .catch(() => {
          this.showToast(this.$t("common.message.unknownError"), "error");
        })
        .finally(() => {
          this.isHtUploadLoading = false;
        });
    },
    /**
     * ロケ別実績ダイアログ表示
     */
    openLocationDialog(data) {
      this.selectedLocation = data;
      this.locationDialog = {
        janCode: data.janCode ?? "",
        productName: data.productName ?? "",
        productCode: data.productCode ?? "",
        colorCode: data.colorCode ?? "",
        colorName: data.colorName ?? "",
        sizeCode: data.sizeCode ?? "",
        sizeName: data.sizeName ?? "",
        planSuuryo: data.planSuuryo ?? null,
        locationList: [],
        loading: true,
        isApvInventory: this.isApvInventory,
        canAdjustment: this.canAdjustment,
        adjustmentInfo: data.adjustmentInfo,
      };
      this.locationDialogVisible = true;

      api.post("/tanaoroshi/diff/location/search", {
        tanaoroshiId: this.tanaoroshi?.tanaoroshiId ?? "",
        shopCode: this.shopCode ?? "",
        janCode: data.janCode ?? "",
      })
      .then((response) => {
        if (response.data.status == '1') {
          const message = response.data.errorMessage
            ?? this.$t("tanaoroshiSai.message.loadLocationError");
          this.showToast(message, "error");
          return;
        }
        this.locationDialog.locationList = response.data.results?.locationList ?? [];
      })
      .catch(() => {
        this.showToast(this.$t("tanaoroshiSai.message.loadLocationError"), "error");
      })
      .finally(() => {
        this.locationDialog.loading = false;
      });
    },
    /**
     * ロケ別実績ダイアログを閉じる
     */
    closeLocationDialog() {
      this.locationDialogVisible = false;
    },
    /**
     * ロケ別実績ダイアログで入力された調整情報を、対象行に保持する(DB反映は保存ボタンで行う)
     * @param saveData ダイアログで入力された情報
     */
    saveLocationDialog(saveData) {
      this.selectedLocation.adjustmentInfo = saveData;
      this.locationDialogVisible = false;
    },
    /**
     * ロケ別の数量調整情報を保持しているかを判定する(上位棚卸用)
     * @param e 行データ
     */
    hasAdjustmentInfoForApv(e) {
      return e?.adjustmentInfo?.length > 0;
    },
    getTimestamp() {
      const date = new Date();
      return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, "0")}`
        + `${String(date.getDate()).padStart(2, "0")}${String(date.getHours()).padStart(2, "0")}`
        + `${String(date.getMinutes()).padStart(2, "0")}${String(date.getSeconds()).padStart(2, "0")}`
        + `${String(date.getMilliseconds()).padStart(3, "0")}`;
    },
  },
  created() {
    TableSorter.fetchSizeDisplayOrderMap();
  },
  mounted() {
    this.displayPerPage = utils.getDisplayPerPage(this.$t)
    this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);

    //propで渡された選択中zoneCodeをformにbindしているものに移す
    if (!store.hasTanaoroshiParam()) {
      this.dataError = true;
    }
    else {
      this.tanaoroshi = store.getTanaoroshi();
      this.shopCode = store.getTanaShopCode();
      this.searchCondition.targetZoneCode = store.getTanaZoneCode();
      if(this.tanaoroshi?.zoneList.at(0).zoneCode == this.searchCondition.targetZoneCode) this.searchCondition.targetZoneCode = null;
      this.reload()
    }
    
  }
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
}

.print_content {
  display: none;
  font-size: 12px;
  font-weight: bold;
  color: #555;
  text-align: left;
}

.print_head {
  padding-left: 2px;
}

.print_data_row {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.print_head,
.print_data {
  width: 9%;
  padding: 4px 2px;
  border-bottom: 1px solid #ccc;
  word-break: break-all;
}
.print_only {
  display: none !important;
}
.list__row--has-adjustment-for-apv {
  color: red;
}
@media print {
  .v-main {
    padding: 0 0 0 0 !important;
  }

  .v-btn {
    display: none !important;
  }

  .v-data-table {
    display: none !important;
  }

  .print_col {
    margin: 0;
    padding: 0;
  }

  .print_content {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .no_print {
    display: none !important;
  }
  .print_only {
    display: block !important;
  }
  .list__row--has-adjustment-for-apv {
    color: unset;
  }
}
</style>
